import "sticky-kit/dist/sticky-kit.js"
import throttle from "lodash/throttle"

import * as $ from "jquery"

export default function docsSetup(navSelector, docsSelector) {
  makeNavSticky(navSelector)
  highlightNavOnScroll(navSelector, docsSelector)
}

function makeNavSticky(navSelector) {
  $(navSelector).stick_in_parent()
}

function highlightNavOnScroll(navSelector, docsSelector) {
  const $navigationLinks = $(navSelector).find("li a")
  const $navigationLinksBySectionId = {}

  $navigationLinks.each((_, link) => {
    const sectionId = link.hash && link.hash.slice(1)

    if (sectionId) {
      $navigationLinksBySectionId[sectionId] = $(link)
    }
  })

  const $sectionHeaders = []

  $(docsSelector)
    .find("h1, h2, h3, h4, h5, h6")
    .each((_, header) => {
      if (header.id in $navigationLinksBySectionId) {
        $sectionHeaders.unshift($(header))
      }
    })

  const handler = throttle(
    handleScroll.bind(
      null,
      $sectionHeaders,
      $navigationLinks,
      $navigationLinksBySectionId
    ),
    100
  )

  $(window).on("scroll", handler)
  $(document).one("turbolinks:visit", () => $(window).off("scroll", handler))
}

function handleScroll(
  $sectionHeaders,
  $navigationLinks,
  $navigationLinksBySectionId
) {
  const scrollPosition = $(window).scrollTop()

  $sectionHeaders.some($sectionHeader => {
    // Add a buffer of 10-ish extra pixels above each header, since the `top`
    // is below the point the browser navigates to when you go to the anchor.
    const sectionTop = $sectionHeader.offset().top - 10

    if (scrollPosition >= sectionTop) {
      const $navigationLink =
        $navigationLinksBySectionId[$sectionHeader.attr("id")]

      if (!$navigationLink.hasClass("active")) {
        $navigationLinks.removeClass("active")
        $navigationLink.addClass("active")
      }

      return true
    }
  })
}
